import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, MaxWidth, Typography } from '@pitchero/react-ui';
import Pagination from '../../pagination';
import NoBackground from '../../club-frame/header/no-background';
import { Trans } from '../../../lib/i18n';
import FilterBar from '../filter-bar';
import ProductList from '../product-list';

const ShopCategoryPage = ({ category, isLoading, products, page, pagination, categories }) => (
  <>
    <NoBackground />
    <FilterBar selectedCategory={category} categories={categories} />
    <Cushion
      vertical="large"
      horizontal="small"
      component="div"
      responsive={[
        {
          minWidth: 'tab',
          props: {
            horizontal: 'large',
            vertical: 'xlarge',
          },
        },
      ]}
    >
      <MaxWidth component="div" maxWidth={1366} center>
        <Cushion bottom="medium" component="div">
          <Typography preset="subNavContentHeading" color="black">
            <Trans i18nKey={`shop:${category}`}>Category</Trans>
          </Typography>
        </Cushion>
        <ProductList isLoading={isLoading} products={products} />
      </MaxWidth>
    </Cushion>
    {pagination && (
      <Pagination {...pagination} page={page} route="shop.category" routeParams={{ category }} />
    )}
  </>
);

ShopCategoryPage.defaultProps = {
  pagination: null,
};

ShopCategoryPage.propTypes = {
  category: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  isLoading: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  page: PropTypes.number.isRequired,
  pagination: PropTypes.shape({
    page: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    totalResults: PropTypes.number.isRequired,
  }),
};

export default ShopCategoryPage;
